"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAuthorizedStateDto = instanceOfAuthorizedStateDto;
exports.AuthorizedStateDtoFromJSON = AuthorizedStateDtoFromJSON;
exports.AuthorizedStateDtoFromJSONTyped = AuthorizedStateDtoFromJSONTyped;
exports.AuthorizedStateDtoToJSON = AuthorizedStateDtoToJSON;
exports.AuthorizedStateDtoToJSONTyped = AuthorizedStateDtoToJSONTyped;
const NurseStatePracticeAuthorizationCode_1 = require("./NurseStatePracticeAuthorizationCode");
const State_1 = require("./State");
/**
 * Check if a given object implements the AuthorizedStateDto interface.
 */
function instanceOfAuthorizedStateDto(value) {
    if (!('practiceCode' in value) || value['practiceCode'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    return true;
}
function AuthorizedStateDtoFromJSON(json) {
    return AuthorizedStateDtoFromJSONTyped(json, false);
}
function AuthorizedStateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'practiceCode': (0, NurseStatePracticeAuthorizationCode_1.NurseStatePracticeAuthorizationCodeFromJSON)(json['practiceCode']),
        'state': (0, State_1.StateFromJSON)(json['state']),
    };
}
function AuthorizedStateDtoToJSON(json) {
    return AuthorizedStateDtoToJSONTyped(json, false);
}
function AuthorizedStateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'practiceCode': (0, NurseStatePracticeAuthorizationCode_1.NurseStatePracticeAuthorizationCodeToJSON)(value['practiceCode']),
        'state': (0, State_1.StateToJSON)(value['state']),
    };
}
//# sourceMappingURL=AuthorizedStateDto.js.map